import React from 'react';
import PropTypes from 'prop-types';
import '../Checkout/css/Checkout.css';
import {
  FIRST_NAME,
  LAST_NAME,
  DATE_OF_BIRTH,
  CITIZENSHIP,
  PASSPORT,
  SEX,
  PASSPORT_DATE_START,
  PASSPORT_DATE_END,
  PASSPORT_IDENTIFICATION,
  DATE_PH,
  PASSPORT_PH,
  RUS_LETTERS_ERROR,
  FIRST_NAME_LAT,
  LAST_NAME_LAT,
  LAT_LETTERS_ERROR,
  CITIZENSHIP_PH,
  MALE_SEX,
  FEMALE_SEX,
} from '../../Utils/Constants/CheckoutConstants';
import {
  onlyRusLetters,
  passportSeriaAndNumber,
  onlyLatLetters,
} from '../../Utils/ValidationUtil';
import Input from '../Input/Input';

// one tourist fields: checkout and the user cabinet
function TouristForm(props) {
  const {
    title,
    tourist,
    handleChange,
    handleValid,
    handleSexChange,
    children,
  } = props;
  const { id } = tourist;

  const getSexClass = (sex) =>
    `ch_sex_button ${tourist.sex === sex ? 'ch_sex_selected' : ''}`;

  return (
    <div className="ch_section_w">
      <div className="bb_text_20 mb_20">{title}</div>
      <div className="ch_inputs_w">
        <Input
          id={id}
          name="lastNameUpper"
          label={LAST_NAME}
          placeholder={FIRST_NAME_LAT}
          value={tourist.lastNameUpper}
          handleValueChange={handleChange}
          validation={onlyLatLetters}
          validationError={LAT_LETTERS_ERROR}
          isValid={tourist.lastNameUpperValid}
          isValidChange={handleValid}
          required
        />
        <Input
          id={id}
          name="firstNameUpper"
          label={FIRST_NAME}
          placeholder={LAST_NAME_LAT}
          value={tourist.firstNameUpper}
          handleValueChange={handleChange}
          validation={onlyLatLetters}
          validationError={LAT_LETTERS_ERROR}
          isValid={tourist.firstNameUpperValid}
          isValidChange={handleValid}
          required
        />
        <Input
          id={id}
          name="birthDay"
          label={DATE_OF_BIRTH}
          placeholder={DATE_PH}
          value={tourist.birthDay}
          handleValueChange={handleChange}
          type="date"
          isValid={tourist.birthDayValid}
          isValidChange={handleValid}
          required
        />
      </div>
      <div className="ch_inputs_w">
        <Input
          id={id}
          name="passport"
          label={PASSPORT}
          placeholder={PASSPORT_PH}
          value={tourist.passport}
          handleValueChange={handleChange}
          validation={passportSeriaAndNumber}
          validationError={LAT_LETTERS_ERROR}
          isValid={tourist.passportValid}
          isValidChange={handleValid}
          maxLength={9}
          required
        />
        <Input
          id={id}
          label={PASSPORT_DATE_START}
          name="passportStartDate"
          placeholder={DATE_PH}
          type="date"
          value={tourist.passportStartDate}
          handleValueChange={handleChange}
          isValid={tourist.passportStartDateValid}
          isValidChange={handleValid}
          required
        />
        <Input
          id={id}
          label={PASSPORT_DATE_END}
          name="passportEndDate"
          placeholder={DATE_PH}
          type="date"
          value={tourist.passportEndDate}
          handleValueChange={handleChange}
          isValid={tourist.passportEndDateValid}
          isValidChange={handleValid}
          required
        />
      </div>
      <div className="ch_inputs_w">
        <Input
          id={id}
          label={PASSPORT_IDENTIFICATION}
          name="identity"
          value={tourist.identity}
          handleValueChange={handleChange}
          validation={passportSeriaAndNumber}
          validationError={LAT_LETTERS_ERROR}
          isValid={tourist.identityValid}
          isValidChange={handleValid}
          required
        />
        <Input
          id={id}
          name="citizenship"
          label={CITIZENSHIP}
          placeholder={CITIZENSHIP_PH}
          value={tourist.citizenship}
          handleValueChange={handleChange}
          validation={onlyRusLetters}
          validationError={RUS_LETTERS_ERROR}
          isValid={tourist.citizenshipValid}
          isValidChange={handleValid}
          required
        />
        <div className="ch_tourist_sex">
          <div className="from_label">
            <span className="gr_text_14">{SEX}</span>
            &nbsp;
            <span className="input_required">*</span>
          </div>
          <div className="ch_tourist_sex_slector_w">
            <button
              type="button"
              value="male"
              className={getSexClass('male')}
              onClick={() => handleSexChange('male', id)}
            >
              {MALE_SEX}
            </button>
            <button
              type="button"
              value="female"
              className={getSexClass('female')}
              onClick={() => handleSexChange('female', id)}
            >
              {FEMALE_SEX}
            </button>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}

TouristForm.propTypes = {
  title: PropTypes.string.isRequired,
  tourist: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleValid: PropTypes.func.isRequired,
  handleSexChange: PropTypes.func.isRequired,
  // e.g. save buttons at the bottom of the section
  children: PropTypes.node,
};

TouristForm.defaultProps = {
  children: null,
};

export default TouristForm;
